<script setup>
  import { computed } from "vue";
  import { useMapStore } from "@/stores/MapStore";
  import { useProductStore } from "@/stores/ProductStore";
  import { useSheetController } from '@/composables/useSheetsController';
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore'; 
  import MapMenuSelect from "@/components/MapMenuSelect.vue";
  import Icon from "@/components/icons/Icon.vue";

  const mapStore = useMapStore();
  const productStore = useProductStore();
  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const mapName = computed(() => mapStore.state.shortName !== '' ? mapStore.state.shortName : mapStore.state.name);
  const overlayName = computed(() => {
    return mapStore.state.id === 'unsaved' || mapStore.state.name === 'Unsaved Map'
      ? 'unsaved-map'
      : mapStore.state.id > 999
      ? 'saved-map' 
      : productStore.getProduct(mapStore.state.id)?.overlayName;
  });

  function handleCick() {
    useSheetController.toggleSheet('config', 'map-selection');
    googleAnalyticsStore.sendEvent('Show_Map_Regional_Products', {'Initiator': 'Map_Name'});
  }  
</script>

<template>
  <div class="jwx-map__name jwx-wrapper-block jwx-wrapper-block--transparent-border" data-map="map-name">
    <div class="jwx-wrapper-block__content">
      <div class="jwx-map-name">
        <MapMenuSelect
          @buttonClick="handleCick"
        >
          <template #icon>
            <Icon v-if="overlayName" :name="overlayName" :key="overlayName" />
          </template>
          <template #label>
            {{ mapName }}
          </template>
        </MapMenuSelect>   
      </div>
    </div>
  </div>
</template>